// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-checkbox {
  white-space: nowrap;
  max-width: 100%;
  display: inline-block;
  position: relative;
}
fi-checkbox .mat-mdc-checkbox {
  z-index: 4;
  line-height: 2;
}
fi-checkbox .mat-mdc-checkbox > label {
  margin-bottom: 0;
}

.CcmCheckBox {
  width: 13px;
  margin: 0px auto;
  position: relative;
  display: inline;
  white-space: nowrap;
}
.CcmCheckBox .Disabled:after {
  border-color: var(--fi-color-black);
}
.CcmCheckBox .Disabled:hover:after {
  opacity: 0;
}
.CcmCheckBox input[type=checkbox] {
  visibility: hidden;
}
.CcmCheckBox input[type=checkbox]:checked + label:after {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: alpha(opacity=100);
  opacity: 1;
}
.CcmCheckBox label {
  position: absolute;
  width: 13px;
  height: 13px;
  top: 2px;
  border-radius: 4px;
  box-shadow: inset 0 0 2px var(--fi-color-black);
  background-image: linear-gradient(#fefefe, #e7e7e7);
  left: 0px;
}
.CcmCheckBox label:after {
  transform: rotate(-45deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: alpha(opacity=0);
  opacity: 0;
  content: "";
  position: absolute;
  width: 9px;
  height: 5px;
  background: transparent;
  top: 4px;
  left: 2px;
  border: 3px solid;
  border-color: inherit;
  border-top: none;
  border-right: none;
}
.CcmCheckBox label:hover:after {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=25)";
  filter: alpha(opacity=25);
  opacity: 0.25;
}

.ToggleIcon {
  /*CheckboxList has padding: 25px for extra space*/
  margin-left: -20px;
  margin-right: 5px;
  border: 1px solid var(--fi-border-color-dark);
  border-radius: 3px;
  vertical-align: middle;
  background: var(--fi-color-white);
  cursor: pointer;
}

/*Cant use ng-show attribute since i have to override HideChildren class for mobile devices*/
.ShowChildren {
  display: block;
}

.HideChildren {
  display: none;
}

/*END OF*/
/*Plus Icon*/
.PlusIcon {
  top: 3px;
  position: absolute;
  height: 11px;
  width: 11px;
  display: inline-block;
  z-index: 3;
  background: var(--fi-color-white);
}
.PlusIcon:before {
  /*VERTICAL*/
  content: "";
  position: absolute;
  height: 5px;
  top: 2px;
  left: 4px;
  border-right: 1px solid var(--fi-border-color-dark);
}
.PlusIcon:after {
  /*HORIZONTAL*/
  content: "";
  position: absolute;
  width: 5px;
  left: 2px;
  top: 4px;
  border-bottom: 1px solid var(--fi-border-color-dark);
}

/*END OF Plus Icon*/
/*Minus Icon*/
.MinusIcon {
  top: 3px;
  position: absolute;
  height: 11px;
  width: 11px;
  display: inline-block;
  background: var(--fi-color-white);
  z-index: 3;
}
.MinusIcon:after {
  /*HORIZONTAL*/
  content: "";
  position: absolute;
  width: 5px;
  left: 2px;
  top: 4px;
  border-bottom: 1px solid var(--fi-border-color-dark);
}

/*END OF Minus Icon*/
/*Dotted styles*/
.ToggleDash {
  display: block;
  position: absolute;
  border-top: 1px dotted var(--fi-border-color-dark);
  width: 20px;
  left: -20px;
  top: 8px;
  z-index: 1;
}

.itemParent {
  margin-bottom: 2px;
}
.itemParent .CcmCheckBoxListChildWrap {
  position: relative;
  margin-left: 24px;
}
.itemParent .CcmCheckBoxListChildWrap .CcmCheckBoxListChildBorder {
  height: calc(100% - 8px);
  top: -5px;
  background: #ffffff;
  border-bottom: 1px solid #ffffff;
  box-sizing: border-box;
  border-left: 1px dotted var(--fi-border-color-dark);
  position: absolute;
  left: -16px;
  z-index: 2;
}

.DottedNonChildItems {
  content: "";
  border-top: 1px dotted var(--fi-border-color-dark);
  border-left: 1px solid var(--fi-color-white);
  position: absolute;
  top: 9px;
  width: 16px;
  display: inline-block;
  left: -16px;
}

/*END OF Dotted styles*/
.fi-checkbox-main {
  position: relative;
}
.fi-checkbox-main > .ToggleIcon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.fi-checkbox-main > .ToggleDash,
.fi-checkbox-main .DottedNonChildItems {
  position: absolute;
  top: 50%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checkbox/checkbox.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AACJ;AACI;EACI,UAAA;EACA,cAAA;AACR;AACQ;EACI,gBAAA;AACZ;;AAIA;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AADJ;AAIQ;EACI,mCAAA;AAFZ;AAKQ;EACI,UAAA;AAHZ;AAOI;EACI,kBAAA;AALR;AAOQ;EACI,kEAAA;EACA,0BAAA;EACA,UAAA;AALZ;AASI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EAGA,+CAAA;EACA,mDAAA;EACA,SAAA;AAPR;AASQ;EACI,yBAAA;EACA,gEAAA;EACA,wBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAPZ;AAUQ;EACI,iEAAA;EACA,yBAAA;EACA,aAAA;AARZ;;AAaA;EACI,iDAAA;EACA,kBAAA;EACA,iBAAA;EACA,6CAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,eAAA;AAVJ;;AAaA,4FAAA;AACA;EACI,cAAA;AAVJ;;AAaA;EACI,aAAA;AAVJ;;AAaA,SAAA;AAEA,YAAA;AACA;EACI,QAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;EACA,iCAAA;AAXJ;AAaI;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mDAAA;AAXR;AAcI;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,oDAAA;AAZR;;AAgBA,mBAAA;AAEA,aAAA;AACA;EACI,QAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,iCAAA;EACA,UAAA;AAdJ;AAgBI;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,oDAAA;AAdR;;AAkBA,oBAAA;AAEA,gBAAA;AACA;EACI,cAAA;EACA,kBAAA;EACA,kDAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;AAhBJ;;AAkBA;EACI,kBAAA;AAfJ;AAiBI;EACI,kBAAA;EACA,iBAAA;AAfR;AAiBQ;EACI,wBAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;EAGA,sBAAA;EACA,mDAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAfZ;;AAoBA;EACI,WAAA;EACA,kDAAA;EACA,4CAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;AAjBJ;;AAoBA,uBAAA;AAEA;EACI,kBAAA;AAlBJ;AAoBI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;AAlBR;AAqBI;;EAEI,kBAAA;EACA,QAAA;AAnBR","sourcesContent":["fi-checkbox {\r\n    white-space: nowrap;\r\n    max-width: 100%;\r\n    display: inline-block;\r\n    position: relative;\r\n\r\n    .mat-mdc-checkbox {\r\n        z-index: 4;\r\n        line-height: 2;\r\n\r\n        > label {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.CcmCheckBox {\r\n    width: 13px;\r\n    margin: 0px auto;\r\n    position: relative;\r\n    display: inline;\r\n    white-space: nowrap;\r\n\r\n    .Disabled {\r\n        &:after {\r\n            border-color: var(--fi-color-black);\r\n        }\r\n\r\n        &:hover:after {\r\n            opacity: 0;\r\n        }\r\n    }\r\n\r\n    input[type='checkbox'] {\r\n        visibility: hidden;\r\n\r\n        &:checked + label:after {\r\n            -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';\r\n            filter: alpha(opacity=100);\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    label {\r\n        position: absolute;\r\n        width: 13px;\r\n        height: 13px;\r\n        top: 2px;\r\n        border-radius: 4px;\r\n        -moz-box-shadow: inset 0 0 2px var(--fi-color-black);\r\n        -webkit-box-shadow: inset 0 0 2px var(--fi-color-black);\r\n        box-shadow: inset 0 0 2px var(--fi-color-black);\r\n        background-image: linear-gradient(#fefefe, #e7e7e7);\r\n        left: 0px;\r\n\r\n        &:after {\r\n            transform: rotate(-45deg);\r\n            -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)';\r\n            filter: alpha(opacity=0);\r\n            opacity: 0;\r\n            content: '';\r\n            position: absolute;\r\n            width: 9px;\r\n            height: 5px;\r\n            background: transparent;\r\n            top: 4px;\r\n            left: 2px;\r\n            border: 3px solid;\r\n            border-color: inherit;\r\n            border-top: none;\r\n            border-right: none;\r\n        }\r\n\r\n        &:hover:after {\r\n            -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=25)';\r\n            filter: alpha(opacity=25);\r\n            opacity: 0.25;\r\n        }\r\n    }\r\n}\r\n\r\n.ToggleIcon {\r\n    /*CheckboxList has padding: 25px for extra space*/\r\n    margin-left: -20px;\r\n    margin-right: 5px;\r\n    border: 1px solid var(--fi-border-color-dark);\r\n    border-radius: 3px;\r\n    vertical-align: middle;\r\n    background: var(--fi-color-white);\r\n    cursor: pointer;\r\n}\r\n\r\n/*Cant use ng-show attribute since i have to override HideChildren class for mobile devices*/\r\n.ShowChildren {\r\n    display: block;\r\n}\r\n\r\n.HideChildren {\r\n    display: none;\r\n}\r\n\r\n/*END OF*/\r\n\r\n/*Plus Icon*/\r\n.PlusIcon {\r\n    top: 3px;\r\n    position: absolute;\r\n    height: 11px;\r\n    width: 11px;\r\n    display: inline-block;\r\n    z-index: 3;\r\n    background: var(--fi-color-white);\r\n\r\n    &:before {\r\n        /*VERTICAL*/\r\n        content: '';\r\n        position: absolute;\r\n        height: 5px;\r\n        top: 2px;\r\n        left: 4px;\r\n        border-right: 1px solid var(--fi-border-color-dark);\r\n    }\r\n\r\n    &:after {\r\n        /*HORIZONTAL*/\r\n        content: '';\r\n        position: absolute;\r\n        width: 5px;\r\n        left: 2px;\r\n        top: 4px;\r\n        border-bottom: 1px solid var(--fi-border-color-dark);\r\n    }\r\n}\r\n\r\n/*END OF Plus Icon*/\r\n\r\n/*Minus Icon*/\r\n.MinusIcon {\r\n    top: 3px;\r\n    position: absolute;\r\n    height: 11px;\r\n    width: 11px;\r\n    display: inline-block;\r\n    background: var(--fi-color-white);\r\n    z-index: 3;\r\n\r\n    &:after {\r\n        /*HORIZONTAL*/\r\n        content: '';\r\n        position: absolute;\r\n        width: 5px;\r\n        left: 2px;\r\n        top: 4px;\r\n        border-bottom: 1px solid var(--fi-border-color-dark);\r\n    }\r\n}\r\n\r\n/*END OF Minus Icon*/\r\n\r\n/*Dotted styles*/\r\n.ToggleDash {\r\n    display: block;\r\n    position: absolute;\r\n    border-top: 1px dotted var(--fi-border-color-dark);\r\n    width: 20px;\r\n    left: -20px;\r\n    top: 8px;\r\n    z-index: 1;\r\n}\r\n.itemParent {\r\n    margin-bottom: 2px;\r\n\r\n    .CcmCheckBoxListChildWrap {\r\n        position: relative;\r\n        margin-left: 24px;\r\n\r\n        .CcmCheckBoxListChildBorder {\r\n            height: calc(100% - 8px);\r\n            top: -5px;\r\n            background: #ffffff;\r\n            border-bottom: 1px solid #ffffff;\r\n            -moz-box-sizing: border-box;\r\n            -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n            border-left: 1px dotted var(--fi-border-color-dark);\r\n            position: absolute;\r\n            left: -16px;\r\n            z-index: 2;\r\n        }\r\n    }\r\n}\r\n\r\n.DottedNonChildItems {\r\n    content: '';\r\n    border-top: 1px dotted var(--fi-border-color-dark);\r\n    border-left: 1px solid var(--fi-color-white);\r\n    position: absolute;\r\n    top: 9px;\r\n    width: 16px;\r\n    display: inline-block;\r\n    left: -16px;\r\n}\r\n\r\n/*END OF Dotted styles*/\r\n\r\n.fi-checkbox-main {\r\n    position: relative;\r\n\r\n    > .ToggleIcon {\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n    }\r\n\r\n    > .ToggleDash,\r\n    .DottedNonChildItems {\r\n        position: absolute;\r\n        top: 50%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
